import "../ActivitySignalBanner.css";
import { useEffect, useState } from 'react';
import "../ActivitySignalBanner.css"
import { getCategoryColor, getCategoryIcon } from "../utility/colorForCategoryUtils";

const ActivitySignalBanner = ({showBannerIdx = 1}) => {
  // 1. Initialize state with the first message or a default
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [index, setIndex] = useState(0);
  const [shouldLoop, setShouldLoop] = useState(false); // State to track the 'circle' flag
  const [isVisible, setIsVisible] = useState(true);
  const colors = getCategoryColor(new Date().getSeconds());
  //const icon = getCategoryIcon();
  
  

  const handleClick = async (event) => {
    if (event) event.preventDefault(); // Ensure event exists before calling preventDefault()  
  } 

  // 2. Load messages and setup the interval correctly
  useEffect(() => {
    const rawData = localStorage.getItem('init');
    if (rawData) {
      try {
        const parsedData = JSON.parse(rawData);

        // 1. Check if the feature is even enabled
        if (parsedData?.as?.feature === false) {
          setMessages([]); // Ensure messages are empty so nothing renders
          return;
        }

        const msgs = parsedData.as.messages;        
        const circleFlag = parsedData?.as?.circle !== false;
        const showBanner = parsedData?.as?.showBannerIdx?.includes(showBannerIdx);
        
        setIsVisible(showBanner)
        setMessages(msgs);
        setShouldLoop(circleFlag);
        
        if (msgs?.length > 0) setCurrentMessage(msgs[0]);

      } catch (e) {
        console.error("Error parsing JSON", e);
      }
    }
  }, []); // Runs once on mount

  // 3. Handle the rotation logic
  useEffect(() => {
    if (messages?.length <= 1) return;
    
    const interval = setInterval(() => {
      setIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;

        // If circle is false and we reached the end of the array
        if (!shouldLoop && nextIndex === messages.length) {
          clearInterval(interval); // STOP the loop
          setIsVisible(false); // This will hide the banner
          return prevIndex; // Stay on the last message
        }

        // Normal looping logic
        const finalIndex = nextIndex % messages.length;
        setCurrentMessage(messages[finalIndex]);
        return finalIndex;
      });
    }, 5000);

    return () => clearInterval(interval); // Clean up on unmount
  }, [messages]);

  return (
    <>
      {/* 4. Use the state variable {currentMessage} instead of innerText */}
      {isVisible && messages?.length > 0 && (

        <div className="lp-activity-banner">
              <div className="lp-activity-banner__icon" style={{color: colors.text, background: colors.bg}}>
                <i className={`fa ${getCategoryIcon(currentMessage?.CATEGORY_ICONS)} lp-cat-card__fa`} style={{color: colors.text}}/>
              </div>
              <div className="lp-activity-banner__text">
                {currentMessage?.message && <p className="lp-activity-banner__title">{currentMessage?.message}</p>}
                {/* city available */}
                {currentMessage?.city && <p className="lp-activity-banner__sub text-muted" >{currentMessage?.city} {currentMessage?.time && <span> · {currentMessage?.time}</span>}</p>}
                {/* city not available and time available*/}
                {!currentMessage?.city && currentMessage?.time && <p className="lp-activity-banner__sub text-muted" >{currentMessage?.time && <span>{currentMessage?.time}</span>}</p>}
              </div>
              <span className="lp-activity-banner__live">Live</span>
              {/* Close Button */}
              <button 
                className="banner-close-btn"
                aria-label="Close"
                onClick={(e)=> {e.preventDefault(); setIsVisible(false)}}
              >
                &times;
              </button>
              
        </div>

        // <div className="floating-activity-toast">
        //   <div className="pulse-container">
        //     {/* 🟢 */}
        //     <span className="pulse-dot"></span>
        //   </div>
        //   <p id="activity-text" className="fade-in">
        //     {currentMessage}
        //   </p>
        // </div>
      )}
    </>
  );
}

export default ActivitySignalBanner;
